// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import styles from '@app/features/auth/components/modals/AccountDeleteModal.module.css';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import * as UserCommands from '@app/features/user/commands/UserCommands';
import * as FormUtils from '@app/lib/forms';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';
export const AccountDeleteModal = observer(() => {
	const {t, i18n} = useLingui();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const handleConfirm = async () => {
		setIsSubmitting(true);
		try {
			await UserCommands.deleteAccount();
			ModalCommands.pop();
			RouterUtils.transitionTo('/login');
		} catch (error) {
			FormUtils.pushApiErrorModal(i18n, error);
		} finally {
			setIsSubmitting(false);
		}
	};
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={t`Delete Account`} />
			<Modal.Content contentClassName={styles.content}>
				<div className={styles.infoSection}>
					<p>
						<Trans>
							Are you sure you want to delete your account? This action will schedule your account for permanent
							deletion.
						</Trans>
					</p>
					<div className={styles.infoBox}>
						<p className={styles.infoBoxTitle}>
							<Trans>Important information:</Trans>
						</p>
						<ul className={styles.infoList}>
							<li>
								<Trans>You can cancel the deletion process within 14 days</Trans>
							</li>
							<li>
								<Trans>After 14 days, your account will be permanently deleted</Trans>
							</li>
							<li>
								<Trans>Once deletion is processed, you cannot recover access to your account</Trans>
							</li>
							<li>
								<Trans>You will not be able to delete your sent messages after your account is deleted</Trans>
							</li>
						</ul>
					</div>
					<p className={styles.disclaimer}>
						<Trans>
							If you want to export your data or delete your messages first, please visit the Privacy Dashboard section
							in User Settings before proceeding.
						</Trans>
					</p>
				</div>
			</Modal.Content>
			<Modal.Footer>
				<Button onClick={ModalCommands.pop} variant="secondary">
					<Trans>Cancel</Trans>
				</Button>
				<Button onClick={handleConfirm} submitting={isSubmitting} variant="danger-primary">
					<Trans>Delete Account</Trans>
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
});
